import ERRORS from 'constants/errors';

export const validateEmail = value => {
  if (!/.+@.+/.test(value)) {
    return ERRORS.email;
  }
  return null;
};
